module.exports = __webpack_public_path__ + "img/f6.712d1193.jpg";